import React from "react";
import { DocDnDMessage, DocumentDndBox, SupportedFilesMessage } from "./DocumentPart.styles";
import { DnDIcon } from "../../../../utils/Icons/Part/Document";
import Dropzone from "react-dropzone";
import { ClearField, FieldSet, Input, InputLink } from "../../../../../App/Common/Components/FormComponents";

interface DropZoneProps {
  supportedFilesTypes: string[];
  supportedFilesMbSize: number;
}

export const DropZoneComponent: React.FC<DropZoneProps> = props => {
  const { supportedFilesTypes, supportedFilesMbSize } = props;
  return (
    <DocumentDndBox>
      <DnDIcon />
      <DocDnDMessage>Click to upload or drag and drop the file.</DocDnDMessage>
      <SupportedFilesMessage>
        Supported file types: {supportedFilesTypes.join(", ")} {"\n"}
        Maximum file size: {supportedFilesMbSize} MB
      </SupportedFilesMessage>
    </DocumentDndBox>
  );
};

export const renderDropZone = (onDrop: (files: File[]) => void, children: React.ReactNode, testId?: string) => (
  <Dropzone onDrop={onDrop}>
    {({ getRootProps, getInputProps }) => (
      <div {...getRootProps()} style={{ width: "100%" }}>
        {children}
        <Input {...getInputProps()} data-testid={testId} type="file" name="file" style={{ display: "none" }} />
      </div>
    )}
  </Dropzone>
);

export const renderLinkInput = (
  inputRef: React.RefObject<HTMLInputElement>,
  documentFromURL: string,
  onChangeFileFromURL: (e: React.ChangeEvent<HTMLInputElement>) => void
) => (
  <FieldSet style={{ width: "100%" }}>
    <legend>Import from URL</legend>
    <ClearField inputRef={inputRef}>
      <InputLink
        name="url"
        placeholder="Type here"
        onChange={onChangeFileFromURL}
        value={documentFromURL}
        ref={inputRef}
        data-testid="url-input"
      />
    </ClearField>
  </FieldSet>
);
